var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 423,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M0 0h530v423H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stocks_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-161-4412h1440V5858H-161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9FB",
    d: "M-161 1348h1440v-2711H-161z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#stocks_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -49,
    y: -294,
    width: 580,
    height: 739,
    rx: 16,
    fill: "url(#stocks_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -49,
    y: -294,
    width: 580,
    height: 739,
    rx: 16,
    stroke: "#EEE",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "stocks_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 530,
    height: 423
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 529,
    height: 422,
    rx: 13.5,
    stroke: "#525376"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#stocks_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#stocks_svg__filter1_di)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 573,
    height: 350,
    rx: 16,
    fill: "url(#stocks_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 573,
    height: 350,
    rx: 16,
    stroke: "#EEE"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64.577,
    cy: 56.577,
    r: 3.577,
    fill: "#ED6A5D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.499,
    cy: 56.577,
    r: 3.577,
    fill: "#F4BF4F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.425,
    cy: 56.577,
    r: 3.577,
    fill: "#62C755"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 127,
    y: 85,
    width: 247,
    height: 22,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    stroke: "#000",
    d: "M40 141.5h573.003"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 173,
    width: 119,
    height: 7,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 128,
    y: 153,
    width: 119,
    height: 7,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 128,
    y: 125,
    width: 270,
    height: 7,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 187,
    width: 270,
    height: 9,
    rx: 2,
    fill: "#A3A1BE"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 201,
    width: 270,
    height: 8,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 212,
    width: 270,
    height: 8,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 243,
    width: 119,
    height: 7,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 257,
    width: 270,
    height: 9,
    rx: 2,
    fill: "#A3A1BE"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 271,
    width: 270,
    height: 8,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 282,
    width: 270,
    height: 8,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 313,
    width: 119,
    height: 7,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 327,
    width: 270,
    height: 9,
    rx: 2,
    fill: "#A3A1BE"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 341,
    width: 270,
    height: 8,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 128,
    y: 352,
    width: 270,
    height: 8,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#stocks_svg__filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 178,
    width: 367,
    height: 186,
    rx: 10,
    fill: "url(#stocks_svg__paint2_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 178,
    width: 367,
    height: 186,
    rx: 10,
    stroke: "#EEE",
    strokeWidth: 0.755
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    stroke: "#000",
    d: "M91 211.5h367M91 242.5h367M91 273.5h367M91 304.5h367M91 335.5h367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.263 201l.648-1.99h3.149l.647 1.99h1.978l-3.009-8.727h-2.378L111.286 201h1.977zm1.116-3.43l1.074-3.303h.068l1.074 3.303h-2.216zm7.36 3.43l.648-1.99h3.149l.648 1.99h1.977l-3.008-8.727h-2.378L119.762 201h1.977zm1.117-3.43l1.074-3.303h.068l1.074 3.303h-2.216zm5.856 3.43h1.845v-2.83h1.551c2.007 0 3.175-1.197 3.175-2.94 0-1.734-1.147-2.957-3.128-2.957h-3.443V201zm1.845-4.308v-2.911h1.244c1.065 0 1.581.58 1.581 1.449 0 .865-.516 1.462-1.572 1.462h-1.253zm5.424 4.308h5.587v-1.521h-3.742v-7.206h-1.845V201z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M287.504 192.273h-1.734l-2.161 1.368v1.636l1.999-1.253h.051V201h1.845v-8.727zm1.574 8.727h6.222v-1.509h-3.665v-.059l1.274-1.249c1.794-1.636 2.276-2.454 2.276-3.447 0-1.513-1.236-2.583-3.107-2.583-1.832 0-3.089 1.096-3.085 2.809h1.752c-.005-.836.524-1.347 1.321-1.347.767 0 1.338.477 1.338 1.244 0 .695-.426 1.172-1.219 1.935l-3.107 2.876V201zm10.409.119c1.943.009 3.268-1.265 3.264-3.042.004-1.637-1.138-2.817-2.685-2.817-.959 0-1.807.46-2.199 1.231h-.059c.008-1.7.605-2.757 1.742-2.757.669 0 1.151.367 1.292.976h1.819c-.174-1.436-1.368-2.557-3.111-2.557-2.156 0-3.541 1.748-3.549 4.679-.005 3.196 1.691 4.279 3.486 4.287zm-.009-1.449c-.852 0-1.483-.686-1.483-1.538.004-.848.648-1.538 1.496-1.538.852 0 1.474.669 1.47 1.534.004.873-.631 1.542-1.483 1.542zm4.796 1.441c.545 0 1.018-.456 1.023-1.023a1.036 1.036 0 00-1.023-1.014 1.019 1.019 0 100 2.037zm4.989-8.958c-1.951-.008-3.268 1.27-3.259 3.026.004 1.628 1.133 2.808 2.68 2.808.959 0 1.811-.464 2.199-1.231h.059c-.004 1.73-.605 2.782-1.742 2.782-.669 0-1.151-.366-1.292-1.001h-1.819c.17 1.47 1.363 2.582 3.111 2.582 2.16 0 3.554-1.747 3.549-4.708-.004-3.162-1.691-4.249-3.486-4.258zm.013 1.449c.848 0 1.475.691 1.483 1.522a1.505 1.505 0 01-1.5 1.525c-.852 0-1.461-.665-1.466-1.521-.008-.852.627-1.526 1.483-1.526zm7.478 7.517c1.96 0 3.362-1.078 3.358-2.569.004-1.087-.687-1.862-1.969-2.024v-.069c.976-.174 1.649-.865 1.645-1.845.004-1.376-1.202-2.459-3.009-2.459-1.79 0-3.136 1.049-3.162 2.557h1.769c.021-.665.63-1.095 1.385-1.095.745 0 1.244.452 1.24 1.108.004.686-.58 1.151-1.419 1.151h-.814v1.355h.814c.988 0 1.606.494 1.602 1.197.004.695-.592 1.172-1.436 1.172-.814 0-1.423-.426-1.458-1.065h-1.858c.03 1.525 1.394 2.586 3.312 2.586z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M416.933 201.119c1.96 0 3.362-1.078 3.358-2.569.004-1.087-.686-1.862-1.969-2.024v-.069c.976-.174 1.65-.865 1.645-1.845.005-1.376-1.201-2.459-3.008-2.459-1.79 0-3.137 1.049-3.162 2.557h1.768c.022-.665.631-1.095 1.385-1.095.746 0 1.245.452 1.24 1.108.005.686-.579 1.151-1.419 1.151h-.814v1.355h.814c.989 0 1.607.494 1.603 1.197.004.695-.593 1.172-1.436 1.172-.814 0-1.424-.426-1.458-1.065h-1.858c.03 1.525 1.394 2.586 3.311 2.586zm5.017-.008c.545 0 1.018-.456 1.022-1.023a1.035 1.035 0 00-1.022-1.014 1.019 1.019 0 100 2.037zm5.113.008c1.943 0 3.264-1.265 3.26-3.03.004-1.67-1.164-2.872-2.736-2.872-.767 0-1.428.32-1.734.75h-.052l.226-2.186h3.814v-1.508h-5.335l-.413 4.602 1.64.294c.269-.362.789-.588 1.304-.588.878.004 1.509.639 1.509 1.555 0 .908-.618 1.534-1.483 1.534-.733 0-1.325-.46-1.368-1.137h-1.79c.034 1.508 1.351 2.586 3.158 2.586zm8.824-1.755c.004 1.048.673 1.939 1.922 1.939 1.235 0 1.926-.891 1.921-1.939v-.461c.005-1.056-.669-1.939-1.921-1.939-1.232 0-1.918.891-1.922 1.939v.461zm-4.479-4.995c.004 1.049.673 1.931 1.918 1.931 1.24 0 1.93-.874 1.926-1.931v-.46c.004-1.057-.669-1.939-1.926-1.939-1.219 0-1.914.882-1.918 1.939v.46zm.418 6.631h1.112l6-8.727h-1.112l-6 8.727zm5.301-2.097c.004-.417.17-.848.682-.848.537 0 .677.431.673.848v.461c.004.417-.154.839-.673.839-.52 0-.678-.435-.682-.839v-.461zm-4.47-4.994c.004-.405.162-.848.669-.848.537 0 .681.43.677.848v.46c.004.418-.157.84-.677.84-.503 0-.665-.422-.669-.84v-.46z",
    fill: "#3D982E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.545 226.094h1.875c-.238-1.726-1.759-2.941-3.732-2.941-2.306 0-4.083 1.662-4.083 4.492 0 2.761 1.662 4.474 4.121 4.474 2.203 0 3.775-1.393 3.775-3.69v-1.099h-3.652v1.389h1.875c-.025 1.082-.762 1.768-1.99 1.768-1.385 0-2.258-1.035-2.258-2.859 0-1.816.908-2.842 2.241-2.842.951 0 1.594.49 1.828 1.308zm10.862 1.542c0-2.855-1.772-4.483-4.086-4.483-2.327 0-4.087 1.628-4.087 4.483 0 2.843 1.76 4.483 4.087 4.483 2.314 0 4.086-1.628 4.086-4.483zm-1.87 0c0 1.85-.878 2.851-2.216 2.851-1.343 0-2.216-1.001-2.216-2.851 0-1.849.873-2.85 2.216-2.85 1.338 0 2.216 1.001 2.216 2.85zm10.757 0c0-2.855-1.773-4.483-4.087-4.483-2.326 0-4.086 1.628-4.086 4.483 0 2.843 1.76 4.483 4.086 4.483 2.314 0 4.087-1.628 4.087-4.483zm-1.871 0c0 1.85-.878 2.851-2.216 2.851-1.342 0-2.216-1.001-2.216-2.851 0-1.849.874-2.85 2.216-2.85 1.338 0 2.216 1.001 2.216 2.85zm8.525-1.542h1.875c-.239-1.726-1.76-2.941-3.733-2.941-2.306 0-4.083 1.662-4.083 4.492 0 2.761 1.662 4.474 4.121 4.474 2.203 0 3.776-1.393 3.776-3.69v-1.099h-3.652v1.389h1.875c-.026 1.082-.763 1.768-1.99 1.768-1.385 0-2.259-1.035-2.259-2.859 0-1.816.908-2.842 2.242-2.842.95 0 1.593.49 1.828 1.308z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M276.707 232h6.222v-1.509h-3.665v-.059l1.274-1.249c1.794-1.636 2.276-2.454 2.276-3.447 0-1.513-1.236-2.583-3.107-2.583-1.832 0-3.089 1.096-3.085 2.809h1.752c-.005-.836.524-1.347 1.321-1.347.767 0 1.338.477 1.338 1.244 0 .695-.426 1.172-1.219 1.935l-3.107 2.876V232zm9.049-1.193h-1.5l-.021.477c-.051 1.159-.384 2.348-.507 2.847h1.176c.204-.516.69-1.726.805-2.855l.047-.469zm1.011-.341h4.189V232h1.764v-1.534h1.082v-1.479h-1.082v-5.714h-2.31l-3.643 5.74v1.453zm4.223-1.479h-2.365v-.068l2.297-3.635h.068v3.703zm7.221-5.714h-1.734l-2.161 1.368v1.636l1.999-1.253h.051V232h1.845v-8.727zm1.92 8.727h1.905l3.622-7.197v-1.53h-6.124v1.508h4.215v.06L300.131 232zm5.869.111c.546 0 1.019-.456 1.023-1.023a1.035 1.035 0 00-1.023-1.014 1.018 1.018 0 100 2.037zm4.901.008c1.968 0 3.383-1.052 3.387-2.467-.004-1.091-.843-1.982-1.892-2.156v-.06a1.959 1.959 0 001.568-1.935c-.004-1.35-1.299-2.348-3.063-2.348-1.769 0-3.064.998-3.06 2.348a1.938 1.938 0 001.568 1.935v.06c-1.065.174-1.896 1.065-1.892 2.156-.004 1.415 1.415 2.467 3.384 2.467zm0-1.355c-.878 0-1.466-.52-1.466-1.257 0-.754.618-1.3 1.466-1.3.843 0 1.465.546 1.465 1.3 0 .742-.592 1.257-1.465 1.257zm0-3.899c-.738 0-1.262-.481-1.262-1.172 0-.682.516-1.15 1.262-1.15.741 0 1.261.473 1.261 1.15 0 .691-.528 1.172-1.261 1.172zm4.045 3.601h4.189V232h1.765v-1.534h1.082v-1.479H320.9v-5.714h-2.31l-3.644 5.74v1.453zm4.223-1.479h-2.365v-.068l2.297-3.635h.068v3.703z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M413.707 232h6.222v-1.509h-3.665v-.059l1.274-1.249c1.794-1.636 2.276-2.454 2.276-3.447 0-1.513-1.236-2.583-3.107-2.583-1.832 0-3.089 1.096-3.085 2.809h1.752c-.005-.836.524-1.347 1.321-1.347.767 0 1.338.477 1.338 1.244 0 .695-.426 1.172-1.219 1.935l-3.107 2.876V232zm8.137.111c.546 0 1.019-.456 1.023-1.023a1.035 1.035 0 00-1.023-1.014 1.02 1.02 0 100 2.037zm1.996-.111h6.222v-1.509h-3.665v-.059l1.274-1.249c1.794-1.636 2.276-2.454 2.276-3.447 0-1.513-1.236-2.583-3.107-2.583-1.832 0-3.089 1.096-3.085 2.809h1.751c-.004-.836.525-1.347 1.321-1.347.767 0 1.338.477 1.338 1.244 0 .695-.426 1.172-1.218 1.935l-3.107 2.876V232zm11.836-1.636c.004 1.048.673 1.939 1.922 1.939 1.235 0 1.926-.891 1.922-1.939v-.461c.004-1.056-.67-1.939-1.922-1.939-1.232 0-1.918.891-1.922 1.939v.461zm-4.479-4.995c.004 1.049.673 1.931 1.918 1.931 1.24 0 1.93-.874 1.926-1.931v-.46c.004-1.057-.669-1.939-1.926-1.939-1.219 0-1.914.882-1.918 1.939v.46zm.418 6.631h1.112l6-8.727h-1.112l-6 8.727zm5.301-2.097c.004-.417.17-.848.682-.848.537 0 .677.431.673.848v.461c.004.417-.153.839-.673.839s-.678-.435-.682-.839v-.461zm-4.47-4.994c.004-.405.162-.848.669-.848.537 0 .682.43.677.848v.46c.005.418-.157.84-.677.84-.503 0-.665-.422-.669-.84v-.46z",
    fill: "#3D982E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.759 254.273V263h1.789v-5.702h.073l2.258 5.659h1.219l2.259-5.637h.072V263h1.79v-8.727h-2.276l-2.403 5.863h-.102l-2.404-5.863h-2.275zm15.214 2.51h1.769c-.026-1.556-1.304-2.63-3.247-2.63-1.914 0-3.316 1.057-3.307 2.642-.004 1.287.903 2.025 2.378 2.378l.95.239c.95.23 1.479.503 1.483 1.091-.004.639-.609 1.074-1.547 1.074-.959 0-1.649-.443-1.709-1.317h-1.785c.047 1.888 1.397 2.864 3.515 2.864 2.131 0 3.384-1.019 3.388-2.617-.004-1.453-1.099-2.224-2.616-2.565l-.784-.188c-.759-.174-1.394-.456-1.381-1.082 0-.563.498-.976 1.402-.976.882 0 1.423.401 1.491 1.087zm2.629 6.217h1.845v-3.605h3.55v-1.521h-3.55v-2.08h3.934v-1.521h-5.779V263zm6.187-7.206h2.672V263h1.824v-7.206h2.672v-1.521h-7.168v1.521z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M284.707 263h6.222v-1.509h-3.665v-.059l1.274-1.249c1.794-1.636 2.276-2.454 2.276-3.447 0-1.513-1.236-2.583-3.107-2.583-1.832 0-3.089 1.096-3.085 2.809h1.752c-.005-.836.524-1.347 1.321-1.347.767 0 1.338.477 1.338 1.244 0 .695-.426 1.172-1.219 1.935l-3.107 2.876V263zm10.246.119c1.944 0 3.265-1.265 3.26-3.03.005-1.67-1.163-2.872-2.735-2.872-.767 0-1.428.32-1.735.75h-.051l.226-2.186h3.814v-1.508h-5.335l-.414 4.602 1.641.294c.268-.362.788-.588 1.304-.588.878.004 1.508.639 1.508 1.555 0 .908-.617 1.534-1.483 1.534-.732 0-1.325-.46-1.367-1.137h-1.79c.034 1.508 1.351 2.586 3.157 2.586zm7.844-8.846h-1.734l-2.161 1.368v1.636l1.999-1.253h.051V263h1.845v-8.727zm2.196 8.838c.545 0 1.018-.456 1.022-1.023a1.035 1.035 0 00-1.022-1.014 1.019 1.019 0 100 2.037zm4.989-8.958c-1.951-.008-3.268 1.27-3.26 3.026.005 1.628 1.134 2.808 2.681 2.808.959 0 1.811-.464 2.199-1.231h.059c-.004 1.73-.605 2.782-1.743 2.782-.669 0-1.15-.366-1.291-1.001h-1.819c.17 1.47 1.363 2.582 3.11 2.582 2.161 0 3.554-1.747 3.55-4.708-.004-3.162-1.692-4.249-3.486-4.258zm.013 1.449c.848 0 1.474.691 1.483 1.522a1.505 1.505 0 01-1.5 1.525c-.852 0-1.462-.665-1.466-1.521-.008-.852.626-1.526 1.483-1.526zm7.601 7.517c1.943.009 3.268-1.265 3.264-3.042.004-1.637-1.138-2.817-2.685-2.817-.958 0-1.806.46-2.198 1.231h-.06c.008-1.7.605-2.757 1.743-2.757.669 0 1.15.367 1.291.976h1.82c-.175-1.436-1.368-2.557-3.111-2.557-2.156 0-3.541 1.748-3.55 4.679-.004 3.196 1.692 4.279 3.486 4.287zm-.009-1.449c-.852 0-1.483-.686-1.483-1.538.005-.848.648-1.538 1.496-1.538.852 0 1.475.669 1.47 1.534.005.873-.63 1.542-1.483 1.542z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M420.504 254.273h-1.734l-2.161 1.368v1.636l1.999-1.253h.051V263h1.845v-8.727zm2.196 8.838c.545 0 1.018-.456 1.022-1.023a1.035 1.035 0 00-1.022-1.014 1.019 1.019 0 100 2.037zm2.013-.111h1.905l3.622-7.197v-1.53h-6.124v1.508h4.215v.06L424.713 263zm11.068-1.636c.005 1.048.674 1.939 1.922 1.939 1.236 0 1.926-.891 1.922-1.939v-.461c.004-1.056-.669-1.939-1.922-1.939-1.231 0-1.917.891-1.922 1.939v.461zm-4.478-4.995c.004 1.049.673 1.931 1.917 1.931 1.24 0 1.931-.874 1.926-1.931v-.46c.005-1.057-.669-1.939-1.926-1.939-1.219 0-1.913.882-1.917 1.939v.46zm.417 6.631h1.112l6-8.727h-1.112l-6 8.727zm5.301-2.097c.005-.417.171-.848.682-.848.537 0 .678.431.673.848v.461c.005.417-.153.839-.673.839s-.677-.435-.682-.839v-.461zm-4.47-4.994c.004-.405.162-.848.669-.848.537 0 .682.43.678.848v.46c.004.418-.158.84-.678.84-.503 0-.665-.422-.669-.84v-.46z",
    fill: "#C93F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.263 294l.648-1.99h3.149l.647 1.99h1.978l-3.009-8.727h-2.378L111.286 294h1.977zm1.116-3.43l1.074-3.303h.068l1.074 3.303h-2.216zm5.856-5.297V294h1.79v-5.702h.072l2.259 5.659h1.219l2.258-5.637h.073V294h1.789v-8.727h-2.275l-2.404 5.863h-.102l-2.403-5.863h-2.276zM130.622 294h6.682v-1.521h-4.368l4.359-6.111v-1.095h-6.682v1.521h4.364l-4.355 6.111V294zm14.897-8.727h-1.836v5.488h-.077l-3.767-5.488h-1.62V294h1.846v-5.493h.064l3.796 5.493h1.594v-8.727z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M275.933 294.119c1.96 0 3.362-1.078 3.358-2.569.004-1.087-.686-1.862-1.969-2.024v-.069c.976-.174 1.65-.865 1.645-1.845.005-1.376-1.201-2.459-3.008-2.459-1.79 0-3.137 1.049-3.162 2.557h1.768c.022-.665.631-1.095 1.385-1.095.746 0 1.245.452 1.24 1.108.005.686-.579 1.151-1.419 1.151h-.814v1.355h.814c.989 0 1.607.494 1.603 1.197.004.695-.593 1.172-1.436 1.172-.814 0-1.424-.426-1.458-1.065h-1.858c.03 1.525 1.394 2.586 3.311 2.586zm5.929-1.312h-1.5l-.022.477c-.051 1.159-.383 2.348-.507 2.847h1.176c.205-.516.691-1.726.806-2.855l.047-.469zm1.142 1.193h6.222v-1.509h-3.665v-.059l1.274-1.249c1.794-1.636 2.276-2.454 2.276-3.447 0-1.513-1.236-2.583-3.107-2.583-1.832 0-3.089 1.096-3.085 2.809h1.751c-.004-.836.525-1.347 1.321-1.347.768 0 1.339.477 1.339 1.244 0 .695-.427 1.172-1.219 1.935l-3.107 2.876V294zm10.246.119c1.944 0 3.265-1.265 3.26-3.03.005-1.67-1.163-2.872-2.735-2.872-.768 0-1.428.32-1.735.75h-.051l.226-2.186h3.814v-1.508h-5.335l-.414 4.602 1.641.294c.268-.362.788-.588 1.304-.588.878.004 1.508.639 1.508 1.555 0 .908-.618 1.534-1.483 1.534-.733 0-1.325-.46-1.368-1.137h-1.789c.034 1.508 1.351 2.586 3.157 2.586zm7.469.073c2.195 0 3.52-1.671 3.524-4.547.005-2.855-1.338-4.492-3.524-4.492-2.19 0-3.52 1.633-3.524 4.492-.009 2.868 1.325 4.543 3.524 4.547zm0-1.53c-1.001 0-1.649-1.006-1.645-3.017.004-1.982.648-2.979 1.645-2.979.993 0 1.641.997 1.641 2.979.004 2.011-.644 3.017-1.641 3.017zm5.055 1.449c.545 0 1.018-.456 1.023-1.023a1.036 1.036 0 00-1.023-1.014 1.019 1.019 0 100 2.037zm5.113.008c1.943 0 3.264-1.265 3.26-3.03.004-1.67-1.163-2.872-2.736-2.872-.767 0-1.427.32-1.734.75h-.051l.226-2.186h3.813v-1.508h-5.335l-.413 4.602 1.641.294c.268-.362.788-.588 1.304-.588.877.004 1.508.639 1.508 1.555 0 .908-.618 1.534-1.483 1.534-.733 0-1.325-.46-1.368-1.137h-1.79c.034 1.508 1.351 2.586 3.158 2.586zm7.469.073c2.194 0 3.52-1.671 3.524-4.547.004-2.855-1.338-4.492-3.524-4.492-2.191 0-3.52 1.633-3.524 4.492-.009 2.868 1.325 4.543 3.524 4.547zm0-1.53c-1.002 0-1.649-1.006-1.645-3.017.004-1.982.648-2.979 1.645-2.979.993 0 1.64.997 1.64 2.979.005 2.011-.643 3.017-1.64 3.017z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M422.707 294h6.222v-1.509h-3.665v-.059l1.274-1.249c1.794-1.636 2.276-2.454 2.276-3.447 0-1.513-1.236-2.583-3.107-2.583-1.832 0-3.089 1.096-3.085 2.809h1.752c-.005-.836.524-1.347 1.321-1.347.767 0 1.338.477 1.338 1.244 0 .695-.426 1.172-1.219 1.935l-3.107 2.876V294zm11.836-1.636c.004 1.048.673 1.939 1.922 1.939 1.236 0 1.926-.891 1.922-1.939v-.461c.004-1.056-.669-1.939-1.922-1.939-1.232 0-1.918.891-1.922 1.939v.461zm-4.479-4.995c.005 1.049.674 1.931 1.918 1.931 1.24 0 1.93-.874 1.926-1.931v-.46c.004-1.057-.669-1.939-1.926-1.939-1.219 0-1.913.882-1.918 1.939v.46zm.418 6.631h1.112l6-8.727h-1.112l-6 8.727zm5.301-2.097c.004-.417.17-.848.682-.848.537 0 .677.431.673.848v.461c.004.417-.153.839-.673.839s-.678-.435-.682-.839v-.461zm-4.47-4.994c.004-.405.162-.848.669-.848.537 0 .682.43.677.848v.46c.005.418-.157.84-.677.84-.503 0-.665-.422-.669-.84v-.46z",
    fill: "#3D982E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.759 325h3.728c1.96 0 3.004-1.023 3.004-2.412 0-1.291-.924-2.071-1.917-2.118v-.085c.908-.205 1.577-.848 1.577-1.875 0-1.308-.972-2.237-2.898-2.237h-3.494V325zm1.845-1.509v-2.318h1.547c.886 0 1.436.512 1.436 1.232 0 .656-.448 1.086-1.479 1.086h-1.504zm0-3.566v-2.161h1.402c.818 0 1.282.422 1.282 1.053 0 .69-.562 1.108-1.316 1.108h-1.368zm5.256-2.131h2.672V325h1.823v-7.206h2.672v-1.521h-7.167v1.521zm15.161 1.534c-.243-2.016-1.768-3.175-3.788-3.175-2.305 0-4.065 1.628-4.065 4.483 0 2.847 1.73 4.483 4.065 4.483 2.237 0 3.588-1.487 3.788-3.093l-1.866-.009c-.175.933-.908 1.47-1.892 1.47-1.325 0-2.225-.984-2.225-2.851 0-1.815.887-2.85 2.238-2.85 1.01 0 1.738.583 1.879 1.542h1.866z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M268.933 325.119c1.96 0 3.362-1.078 3.358-2.569.004-1.087-.686-1.862-1.969-2.024v-.069c.976-.174 1.65-.865 1.645-1.845.005-1.376-1.201-2.459-3.008-2.459-1.79 0-3.137 1.049-3.162 2.557h1.768c.022-.665.631-1.095 1.385-1.095.746 0 1.245.452 1.24 1.108.005.686-.579 1.151-1.419 1.151h-.814v1.355h.814c.989 0 1.607.494 1.603 1.197.004.695-.593 1.172-1.436 1.172-.814 0-1.424-.426-1.458-1.065h-1.858c.03 1.525 1.394 2.586 3.311 2.586zm7.44 0c1.969 0 3.384-1.052 3.388-2.467-.004-1.091-.844-1.982-1.892-2.156v-.06a1.959 1.959 0 001.568-1.935c-.004-1.35-1.3-2.348-3.064-2.348-1.768 0-3.064.998-3.059 2.348a1.937 1.937 0 001.568 1.935v.06c-1.066.174-1.897 1.065-1.892 2.156-.005 1.415 1.414 2.467 3.383 2.467zm0-1.355c-.878 0-1.466-.52-1.466-1.257 0-.754.618-1.3 1.466-1.3.844 0 1.466.546 1.466 1.3 0 .742-.592 1.257-1.466 1.257zm0-3.899c-.737 0-1.261-.481-1.261-1.172 0-.682.515-1.15 1.261-1.15.742 0 1.262.473 1.262 1.15 0 .691-.529 1.172-1.262 1.172zm5.922 3.942h-1.5l-.021.477c-.051 1.159-.384 2.348-.507 2.847h1.176c.204-.516.69-1.726.805-2.855l.047-.469zm4.099 1.312c1.96 0 3.362-1.078 3.358-2.569.004-1.087-.686-1.862-1.969-2.024v-.069c.976-.174 1.65-.865 1.645-1.845.005-1.376-1.201-2.459-3.008-2.459-1.79 0-3.137 1.049-3.162 2.557h1.768c.022-.665.631-1.095 1.385-1.095.746 0 1.245.452 1.24 1.108.005.686-.579 1.151-1.419 1.151h-.814v1.355h.814c.989 0 1.607.494 1.603 1.197.004.695-.593 1.172-1.437 1.172-.813 0-1.423-.426-1.457-1.065h-1.858c.03 1.525 1.394 2.586 3.311 2.586zm7.44 0c1.969 0 3.384-1.052 3.388-2.467-.004-1.091-.844-1.982-1.892-2.156v-.06a1.959 1.959 0 001.568-1.935c-.004-1.35-1.3-2.348-3.064-2.348-1.768 0-3.064.998-3.059 2.348a1.937 1.937 0 001.568 1.935v.06c-1.066.174-1.897 1.065-1.892 2.156-.005 1.415 1.414 2.467 3.383 2.467zm0-1.355c-.878 0-1.466-.52-1.466-1.257 0-.754.618-1.3 1.466-1.3.844 0 1.466.546 1.466 1.3 0 .742-.592 1.257-1.466 1.257zm0-3.899c-.737 0-1.261-.481-1.261-1.172 0-.682.515-1.15 1.261-1.15.742 0 1.262.473 1.262 1.15 0 .691-.529 1.172-1.262 1.172zm7.404 5.254c1.96 0 3.362-1.078 3.358-2.569.004-1.087-.686-1.862-1.969-2.024v-.069c.976-.174 1.649-.865 1.645-1.845.004-1.376-1.202-2.459-3.009-2.459-1.789 0-3.136 1.049-3.161 2.557h1.768c.021-.665.631-1.095 1.385-1.095.746 0 1.244.452 1.24 1.108.004.686-.58 1.151-1.419 1.151h-.814v1.355h.814c.989 0 1.607.494 1.602 1.197.005.695-.592 1.172-1.436 1.172-.814 0-1.423-.426-1.457-1.065h-1.858c.03 1.525 1.393 2.586 3.311 2.586zm5.016-.008c.546 0 1.019-.456 1.023-1.023a1.035 1.035 0 00-1.023-1.014 1.018 1.018 0 100 2.037zm4.99-8.958c-1.952-.008-3.269 1.27-3.26 3.026.004 1.628 1.134 2.808 2.68 2.808.959 0 1.811-.464 2.199-1.231h.06c-.004 1.73-.605 2.782-1.743 2.782-.669 0-1.151-.366-1.291-1.001h-1.82c.171 1.47 1.364 2.582 3.111 2.582 2.161 0 3.554-1.747 3.55-4.708-.005-3.162-1.692-4.249-3.486-4.258zm.013 1.449c.848 0 1.474.691 1.483 1.522a1.505 1.505 0 01-1.5 1.525c-.853 0-1.462-.665-1.466-1.521-.009-.852.626-1.526 1.483-1.526zm7.673 7.59c2.195 0 3.52-1.671 3.524-4.547.004-2.855-1.338-4.492-3.524-4.492-2.19 0-3.52 1.633-3.524 4.492-.009 2.868 1.325 4.543 3.524 4.547zm0-1.53c-1.001 0-1.649-1.006-1.645-3.017.004-1.982.648-2.979 1.645-2.979.993 0 1.641.997 1.641 2.979.004 2.011-.644 3.017-1.641 3.017z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M416.053 325h1.904l3.623-7.197v-1.53h-6.124v1.508h4.214v.06L416.053 325zm5.869.111c.546 0 1.019-.456 1.023-1.023a1.035 1.035 0 00-1.023-1.014 1.018 1.018 0 100 2.037zm1.996-.111h6.222v-1.509h-3.665v-.059l1.274-1.249c1.794-1.636 2.276-2.454 2.276-3.447 0-1.513-1.236-2.583-3.107-2.583-1.832 0-3.089 1.096-3.085 2.809h1.752c-.005-.836.524-1.347 1.321-1.347.767 0 1.338.477 1.338 1.244 0 .695-.427 1.172-1.219 1.935l-3.107 2.876V325zm11.836-1.636c.004 1.048.673 1.939 1.922 1.939 1.236 0 1.926-.891 1.922-1.939v-.461c.004-1.056-.669-1.939-1.922-1.939-1.232 0-1.918.891-1.922 1.939v.461zm-4.479-4.995c.004 1.049.674 1.931 1.918 1.931 1.24 0 1.93-.874 1.926-1.931v-.46c.004-1.057-.669-1.939-1.926-1.939-1.219 0-1.914.882-1.918 1.939v.46zm.418 6.631h1.112l6-8.727h-1.112l-6 8.727zm5.301-2.097c.004-.417.17-.848.682-.848.537 0 .677.431.673.848v.461c.004.417-.153.839-.673.839s-.678-.435-.682-.839v-.461zm-4.47-4.994c.004-.405.162-.848.669-.848.537 0 .682.43.677.848v.46c.005.418-.157.84-.677.84-.503 0-.665-.422-.669-.84v-.46z",
    fill: "#C93F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.759 356h5.897v-1.521h-4.052v-2.084h3.733v-1.521h-3.733v-2.08h4.035v-1.521h-5.88V356zm6.515-7.206h2.672V356h1.824v-7.206h2.671v-1.521h-7.167v1.521zm7.848 7.206h1.845v-3.605h3.746V356h1.841v-8.727h-1.841v3.601h-3.746v-3.601h-1.845V356z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M272.707 356h6.222v-1.509h-3.665v-.059l1.274-1.249c1.794-1.636 2.276-2.454 2.276-3.447 0-1.513-1.236-2.583-3.107-2.583-1.832 0-3.089 1.096-3.085 2.809h1.752c-.005-.836.524-1.347 1.321-1.347.767 0 1.338.477 1.338 1.244 0 .695-.426 1.172-1.219 1.935l-3.107 2.876V356zm9.049-1.193h-1.5l-.021.477c-.051 1.159-.384 2.348-.507 2.847h1.176c.204-.516.69-1.726.805-2.855l.047-.469zm4.26 1.312c1.943 0 3.264-1.265 3.26-3.03.004-1.67-1.163-2.872-2.736-2.872-.767 0-1.427.32-1.734.75h-.051l.225-2.186h3.814v-1.508h-5.335l-.413 4.602 1.64.294c.269-.362.789-.588 1.304-.588.878.004 1.509.639 1.509 1.555 0 .908-.618 1.534-1.483 1.534-.733 0-1.325-.46-1.368-1.137h-1.79c.034 1.508 1.351 2.586 3.158 2.586zm4.392-.119h1.905l3.622-7.197v-1.53h-6.124v1.508h4.215v.06L290.408 356zm9.332-8.847c-1.952-.008-3.268 1.27-3.26 3.026.004 1.628 1.134 2.808 2.681 2.808.958 0 1.811-.464 2.198-1.231h.06c-.004 1.73-.605 2.782-1.743 2.782-.669 0-1.15-.366-1.291-1.001h-1.82c.171 1.47 1.364 2.582 3.111 2.582 2.161 0 3.554-1.747 3.55-4.708-.004-3.162-1.692-4.249-3.486-4.258zm.013 1.449c.848 0 1.474.691 1.483 1.522a1.505 1.505 0 01-1.5 1.525c-.852 0-1.462-.665-1.466-1.521-.009-.852.626-1.526 1.483-1.526zm4.966 7.509c.546 0 1.019-.456 1.023-1.023a1.035 1.035 0 00-1.023-1.014 1.02 1.02 0 100 2.037zm5.055.081c2.194 0 3.52-1.671 3.524-4.547.004-2.855-1.338-4.492-3.524-4.492-2.191 0-3.52 1.633-3.524 4.492-.009 2.868 1.325 4.543 3.524 4.547zm0-1.53c-1.002 0-1.649-1.006-1.645-3.017.004-1.982.648-2.979 1.645-2.979.993 0 1.64.997 1.64 2.979.005 2.011-.643 3.017-1.64 3.017zm7.762 1.53c2.194 0 3.519-1.671 3.524-4.547.004-2.855-1.338-4.492-3.524-4.492-2.191 0-3.52 1.633-3.525 4.492-.008 2.868 1.326 4.543 3.525 4.547zm0-1.53c-1.002 0-1.65-1.006-1.645-3.017.004-1.982.647-2.979 1.645-2.979.992 0 1.64.997 1.64 2.979.004 2.011-.643 3.017-1.64 3.017z",
    fill: "#404263"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M416.895 356.119c1.943 0 3.264-1.265 3.26-3.03.004-1.67-1.164-2.872-2.736-2.872-.767 0-1.428.32-1.734.75h-.051l.225-2.186h3.814v-1.508h-5.335l-.413 4.602 1.64.294c.269-.362.789-.588 1.304-.588.878.004 1.509.639 1.509 1.555 0 .908-.618 1.534-1.483 1.534-.733 0-1.325-.46-1.368-1.137h-1.79c.034 1.508 1.351 2.586 3.158 2.586zm4.855-.008c.546 0 1.019-.456 1.023-1.023a1.035 1.035 0 00-1.023-1.014 1.018 1.018 0 100 2.037zm4.983.008c1.943.009 3.268-1.265 3.264-3.042.004-1.637-1.138-2.817-2.685-2.817-.959 0-1.807.46-2.199 1.231h-.059c.008-1.7.605-2.757 1.743-2.757.669 0 1.15.367 1.291.976h1.819c-.174-1.436-1.368-2.557-3.11-2.557-2.157 0-3.542 1.748-3.55 4.679-.004 3.196 1.692 4.279 3.486 4.287zm-.009-1.449c-.852 0-1.483-.686-1.483-1.538.004-.848.648-1.538 1.496-1.538.852 0 1.474.669 1.47 1.534.004.873-.631 1.542-1.483 1.542zm8.858-.306c.004 1.048.673 1.939 1.922 1.939 1.236 0 1.926-.891 1.922-1.939v-.461c.004-1.056-.669-1.939-1.922-1.939-1.232 0-1.918.891-1.922 1.939v.461zm-4.479-4.995c.005 1.049.674 1.931 1.918 1.931 1.24 0 1.93-.874 1.926-1.931v-.46c.004-1.057-.669-1.939-1.926-1.939-1.219 0-1.913.882-1.918 1.939v.46zm.418 6.631h1.112l6-8.727h-1.112l-6 8.727zm5.301-2.097c.004-.417.171-.848.682-.848.537 0 .677.431.673.848v.461c.004.417-.153.839-.673.839s-.678-.435-.682-.839v-.461zm-4.47-4.994c.004-.405.162-.848.669-.848.537 0 .682.43.678.848v.46c.004.418-.158.84-.678.84-.503 0-.665-.422-.669-.84v-.46z",
    fill: "#C93F3F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stocks_svg__paint0_linear",
    x1: 241,
    y1: -294,
    x2: 241,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stocks_svg__paint1_linear",
    x1: 326.5,
    y1: 40,
    x2: 326.5,
    y2: 390,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stocks_svg__paint2_linear",
    x1: 274.5,
    y1: 178,
    x2: 274.5,
    y2: 364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stocks_svg__filter0_d",
    x: -64,
    y: -308,
    width: 614,
    height: 773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stocks_svg__filter1_di",
    x: 23.5,
    y: 25.5,
    width: 606,
    height: 383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.696962 0 0 0 0 0.713378 0 0 0 0 0.770833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stocks_svg__filter2_d",
    x: 80.047,
    y: 167.803,
    width: 391.926,
    height: 210.926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.511,
    dy: 2.266
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.043
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stocks_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-161 -4412)",
    d: "M0 0h1440v10270H0z"
  })))));
}

export default __webpack_public_path__ + "static/stocks.83dd2302.svg";
export { SvgStocks as ReactComponent };